// document.addEventListener("DOMContentLoaded", () => {
//   const root = document.querySelector(".fashion-bundle");
//   if (!root) return;

//   /* --------------------------------------------
//      ELEMENT REFERENCES
//   --------------------------------------------- */
//   const tabButtons = root.querySelectorAll(".fashion-bundle__tab-btn");
//   const tabPanels = root.querySelectorAll("[data-tab-panel]");
//   const selectedListDesktop = root.querySelector("[data-selected-list]");
//   const selectedListMobile = root.querySelector("[data-selected-list-mobile]");
//   const finalBtnDesktop = root.querySelector("[data-bundle-checkout]");
//   const finalBtnMobile = root.querySelector(".fashion-bundle__final-btn-mobile");

//   const tierProgress = root.querySelector("[data-tier-progress]");

//   const msgTop = root.querySelector("[data-message-top]");
//   const msgBottom = root.querySelector("[data-message-bottom]");

//   const msgTopMobile = root.querySelector("[data-message-top-mobile]");
//   const msgBottomMobile = root.querySelector("[data-message-bottom-mobile]");

//   const bundleTotalEls = root.querySelectorAll("[data-bundle-total]");

//   let selectedItems = [];

//   /* --------------------------------------------
//      TIER SETTINGS (FROM DATA ATTRIBUTES)
//   --------------------------------------------- */
//   const tiers = [
//     { items: parseInt(root.dataset.tier1Items), discount: parseInt(root.dataset.tier1Discount) },
//     { items: parseInt(root.dataset.tier2Items), discount: parseInt(root.dataset.tier2Discount) },
//     { items: parseInt(root.dataset.tier3Items), discount: parseInt(root.dataset.tier3Discount) }
//   ];

//   /* --------------------------------------------
//      FORCE FIRST TAB ACTIVE ON PAGE LOAD
//   --------------------------------------------- */
//   if (tabButtons.length > 0 && tabPanels.length > 0) {
//     tabButtons.forEach(btn => btn.classList.remove("active"));
//     tabPanels.forEach(panel => panel.classList.remove("active"));

//     tabButtons[0].classList.add("active");
//     tabPanels[0].classList.add("active");
//   }

//   /* --------------------------------------------
//      TAB SWITCHING
//   --------------------------------------------- */
//   tabButtons.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       tabButtons.forEach((b) => b.classList.remove("active"));
//       btn.classList.add("active");

//       const id = btn.dataset.tab;

//       tabPanels.forEach((panel) => {
//         panel.classList.toggle("active", panel.id === id);
//       });
//     });
//   });

//   /* --------------------------------------------
//      ADD ITEM TO BUNDLE (w/ loader)
//   --------------------------------------------- */
//   root.querySelectorAll("[data-add]").forEach((addBtn) => {
//     addBtn.addEventListener("click", () => {

//       addBtn.classList.add("loading");
//       const originalText = addBtn.textContent;
//       addBtn.innerHTML = `<div class="fashion-bundle__loader"></div>`;

//       const productCard = addBtn.closest("[data-product]");
//       const id = productCard.dataset.productId;
//       const price = parseFloat(productCard.dataset.productPrice);
//       const img = productCard.querySelector("img").src;

//       setTimeout(() => {
//         selectedItems.push({ id, price, img });

//         addBtn.classList.remove("loading");
//         addBtn.textContent = originalText;

//         renderSelected();
//         updateSummary();

//       }, 250);
//     });
//   });

//   /* --------------------------------------------
//      RENDER SLOTS (STATIC 6 SLOTS)
//   --------------------------------------------- */
//   function renderSelected() {
//     const desktopSlots = root.querySelectorAll("[data-slot]");
//     const mobileSlots = root.querySelectorAll("[data-slot-mobile]");

//     const MAX_SLOTS = 6;

//     /* ------------- DESKTOP SLOTS -------------- */
//     desktopSlots.forEach((slot, i) => {

//       slot.innerHTML = "";
//       slot.style.background = "#767676";

//       const item = selectedItems[i];

//       // LAST SLOT (index 5)
//       if (i === MAX_SLOTS - 1) {

//         if (selectedItems.length === MAX_SLOTS) {
//           slot.classList.remove("fashion-bundle__slot--discount");
//           const lastItem = selectedItems[5];
//           slot.innerHTML = `
//             <img src="${lastItem.img}">
//             <div class="fashion-bundle__slot-remove" data-remove="5">&times;</div>
//           `;
//         } else {
//           // keep Save XX% box from HTML — DO NOT CHANGE TEXT
//           slot.classList.add("fashion-bundle__slot--discount");
//           slot.innerHTML = slot.innerHTML; // preserve text from Liquid
//         }
//         return;
//       }

//       // NORMAL SLOTS 0–4
//       if (item) {
//         slot.innerHTML = `
//           <img src="${item.img}">
//           <div class="fashion-bundle__slot-remove" data-remove="${i}">&times;</div>
//         `;
//       }
//     });

//     /* ------------- MOBILE SLOTS -------------- */
//     mobileSlots.forEach((slot, i) => {

//       slot.innerHTML = "";
//       slot.style.background = "#767676";

//       const item = selectedItems[i];

//       if (i === MAX_SLOTS - 1) {

//         if (selectedItems.length === MAX_SLOTS) {
//           slot.classList.remove("fashion-bundle__slot--discount");
//           const lastItem = selectedItems[5];
//           slot.innerHTML = `
//             <img src="${lastItem.img}">
//             <div class="fashion-bundle__slot-remove" data-remove="5">&times;</div>
//           `;
//         } else {
//           slot.classList.add("fashion-bundle__slot--discount");
//           slot.innerHTML = slot.innerHTML; // preserve Liquid content
//         }
//         return;
//       }

//       if (item) {
//         slot.innerHTML = `
//           <img src="${item.img}">
//           <div class="fashion-bundle__slot-remove" data-remove="${i}">&times;</div>
//         `;
//       }
//     });

//     /* REMOVE HANDLERS */
//     root.querySelectorAll("[data-remove]").forEach((btn) => {
//       btn.addEventListener("click", () => {
//         const index = parseInt(btn.dataset.remove);
//         selectedItems.splice(index, 1);
//         renderSelected();
//         updateSummary();
//       });
//     });
//   }

//   /* --------------------------------------------
//      UPDATE SUMMARY (no percent override!)
//   --------------------------------------------- */

//   const lockIcon = `
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <path d="M12 2C13.5524 1.99994 15.0444 2.60157 16.1625 3.67847C17.2806 4.75537 17.9378 6.22371 17.996 7.775L18 8H19C19.5046 7.99984 19.9906 8.19041 20.3605 8.5335C20.7305 8.87659 20.9572 9.34685 20.995 9.85L21 10V20C21.0002 20.5046 20.8096 20.9906 20.4665 21.3605C20.1234 21.7305 19.6532 21.9572 19.15 21.995L19 22H5C4.49542 22.0002 4.00943 21.8096 3.63945 21.4665C3.26947 21.1234 3.04284 20.6532 3.005 20.15L3 20V10C2.99984 9.49542 3.19041 9.00943 3.5335 8.63945C3.87659 8.26947 4.34684 8.04284 4.85 8.005L5 8H6C6 6.4087 6.63214 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2ZM19 10H5V20H19V10ZM12 12C12.4266 12.0001 12.842 12.1367 13.1854 12.3896C13.5289 12.6426 13.7825 12.9988 13.9092 13.4062C14.0358 13.8135 14.0289 14.2507 13.8895 14.6538C13.75 15.057 13.4853 15.405 13.134 15.647L13 15.732V17C12.9997 17.2549 12.9021 17.5 12.7272 17.6854C12.5522 17.8707 12.313 17.9822 12.0586 17.9972C11.8042 18.0121 11.5536 17.9293 11.3582 17.7657C11.1627 17.6021 11.0371 17.3701 11.007 17.117L11 17V15.732C10.6187 15.5119 10.3208 15.1721 10.1523 14.7653C9.98384 14.3586 9.95429 13.9076 10.0682 13.4824C10.1822 13.0571 10.4333 12.6813 10.7825 12.4133C11.1318 12.1453 11.5597 12 12 12ZM12 4C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8H16C16 6.93913 15.5786 5.92172 14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4Z" fill="black"/>
//                 </svg>
//   `;

//   function updateSummary() {
//     const count = selectedItems.length;
//     let subtotal = selectedItems.reduce((sum, item) => sum + item.price, 0);

//     let appliedTier = null;
//     let nextTier = null;

//     tiers.forEach((tier) => {
//       if (count >= tier.items) appliedTier = tier;
//       if (!nextTier && count < tier.items) nextTier = tier;
//     });

//     let finalPrice = subtotal;
//     if (appliedTier) {
//       finalPrice = subtotal - (subtotal * appliedTier.discount / 100);
//     }

//     bundleTotalEls.forEach((el) => (el.textContent = finalPrice.toFixed(2) + "€"));

//     /* PROGRESS BAR ONLY */
//     let progress = 0;
//     if (appliedTier) {
//       progress = appliedTier.discount === tiers[0].discount ? 33 :
//                  appliedTier.discount === tiers[1].discount ? 66 :
//                  100;
//     }
//     tierProgress.style.width = progress + "%";

//     /* IMPORTANT: DO NOT TOUCH percentage text */

//     /* Desktop Messages */
//     if (count === 0) {
//       msgTop.textContent = "Füge Produkte hinzu, um dein Bundle zu starten!";
//       msgBottom.innerHTML = "";
//     } else {
//       if (appliedTier) {
//         msgTop.innerHTML =
//           `Du hast <strong>${count}</strong> Artikel hinzugefügt! <strong> Du sparst ${appliedTier.discount}%!</strong>`;
//         msgBottom.innerHTML = nextTier
//           ? `${lockIcon} Füge ${nextTier.items - count} mehr hinzu, um ${nextTier.discount}% zu sparen`
//           : `${lockIcon} Du hast den maximalen Rabatt erreicht!`
       

//       } else {
//         msgTop.innerHTML = `Du hast <strong>${count}</strong> Artikel hinzugefügt!`;
//         msgBottom.innerHTML = `${lockIcon} Füge mehr hinzu, um Rabatte freizuschalten!`;
//       }
//     }

//     msgTopMobile.innerHTML = msgTop.innerHTML;
//     msgBottomMobile.textContent = msgBottom.innerHTML;
//   }

//   /* --------------------------------------------
//      CHECKOUT — AJAX ADD
//   --------------------------------------------- */
//   function handleCheckout() {
//     if (selectedItems.length === 0) return;

//     finalBtnDesktop.classList.add("loading");
//     finalBtnDesktop.innerHTML = `<div class="fashion-bundle__loader"></div>`;

//     if (finalBtnMobile) {
//       finalBtnMobile.classList.add("loading");
//       finalBtnMobile.innerHTML = `<div class="fashion-bundle__loader"></div>`;
//     }

//     let queue = [...selectedItems];

//     const addNext = () => {
//       if (queue.length === 0) {
//         window.location.href = "/cart";
//         return;
//       }

//       const item = queue.shift();

//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: item.id, quantity: 1 })
//       })
//       .then(addNext)
//       .catch(addNext);
//     };

//     addNext();
//   }

//   finalBtnDesktop.addEventListener("click", handleCheckout);
//   if (finalBtnMobile) {
//     finalBtnMobile.addEventListener("click", handleCheckout);
//   }

//   /* INIT */
//   renderSelected();
//   updateSummary();
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const root = document.querySelector(".fashion-bundle");
//   if (!root) return;

//   /* --------------------------------------------
//      ELEMENT REFERENCES
//   --------------------------------------------- */
//   const tabButtons = root.querySelectorAll(".fashion-bundle__tab-btn");
//   const tabPanels = root.querySelectorAll("[data-tab-panel]");
//   const selectedListDesktop = root.querySelector("[data-selected-list]");
//   const selectedListMobile = root.querySelector("[data-selected-list-mobile]");
//   const finalBtnDesktop = root.querySelector("[data-bundle-checkout]");
//   const finalBtnMobile = root.querySelector(".fashion-bundle__final-btn-mobile");

//   const tierProgress = root.querySelector("[data-tier-progress]");

//   const msgTop = root.querySelector("[data-message-top]");
//   const msgBottom = root.querySelector("[data-message-bottom]");

//   const msgTopMobile = root.querySelector("[data-message-top-mobile]");
//   const msgBottomMobile = root.querySelector("[data-message-bottom-mobile]");

//   const bundleTotalEls = root.querySelectorAll("[data-bundle-total]");

//   let selectedItems = [];

//   /* --------------------------------------------
//      TIER SETTINGS (FROM DATA ATTRIBUTES)
//   --------------------------------------------- */
//   const tiers = [
//     { items: parseInt(root.dataset.tier1Items), discount: parseInt(root.dataset.tier1Discount) },
//     { items: parseInt(root.dataset.tier2Items), discount: parseInt(root.dataset.tier2Discount) },
//     { items: parseInt(root.dataset.tier3Items), discount: parseInt(root.dataset.tier3Discount) }
//   ];

//   /* --------------------------------------------
//      FORCE FIRST TAB ACTIVE ON PAGE LOAD
//   --------------------------------------------- */
//   if (tabButtons.length > 0 && tabPanels.length > 0) {
//     tabButtons.forEach(btn => btn.classList.remove("active"));
//     tabPanels.forEach(panel => panel.classList.remove("active"));

//     tabButtons[0].classList.add("active");
//     tabPanels[0].classList.add("active");
//   }

//   /* --------------------------------------------
//      TAB SWITCHING
//   --------------------------------------------- */
//   tabButtons.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       tabButtons.forEach((b) => b.classList.remove("active"));
//       btn.classList.add("active");

//       const id = btn.dataset.tab;

//       tabPanels.forEach((panel) => {
//         panel.classList.toggle("active", panel.id === id);
//       });
//     });
//   });

//   /* --------------------------------------------
//      ADD ITEM TO BUNDLE (w/ loader)
//   --------------------------------------------- */
//   root.querySelectorAll("[data-add]").forEach((addBtn) => {
//     addBtn.addEventListener("click", () => {

//       addBtn.classList.add("loading");
//       const originalText = addBtn.textContent;
//       addBtn.innerHTML = `<div class="fashion-bundle__loader"></div>`;

//       const productCard = addBtn.closest("[data-product]");
//       const id = productCard.dataset.productId;
//       const price = parseFloat(productCard.dataset.productPrice);
//       const img = productCard.querySelector("img").src;

//       setTimeout(() => {
//         selectedItems.push({ id, price, img });

//         addBtn.classList.remove("loading");
//         addBtn.textContent = originalText;

//         renderSelected();
//         updateSummary();

//       }, 250);
//     });
//   });

//   /* --------------------------------------------
//      RENDER SLOTS (STATIC 6 SLOTS)
//   --------------------------------------------- */
//   function renderSelected() {
//     const desktopSlots = root.querySelectorAll("[data-slot]");
//     const mobileSlots = root.querySelectorAll("[data-slot-mobile]");

//     const MAX_SLOTS = 6;

//     /* ------------- DESKTOP SLOTS -------------- */
//     desktopSlots.forEach((slot, i) => {

//       slot.innerHTML = "";
//       slot.style.background = "#767676";

//       const item = selectedItems[i];

//       // LAST SLOT (index 5)
//       if (i === MAX_SLOTS - 1) {

//         if (selectedItems.length === MAX_SLOTS) {
//           slot.classList.remove("fashion-bundle__slot--discount");
//           const lastItem = selectedItems[5];
//           slot.innerHTML = `
//             <img src="${lastItem.img}">
//             <div class="fashion-bundle__slot-remove" data-remove="5">&times;</div>
//           `;
//         } else {
//           // keep Save XX% box from HTML — DO NOT CHANGE TEXT
//           slot.classList.add("fashion-bundle__slot--discount");
//           slot.innerHTML = slot.innerHTML; // preserve text from Liquid
//         }
//         return;
//       }

//       // NORMAL SLOTS 0–4
//       if (item) {
//         slot.innerHTML = `
//           <img src="${item.img}">
//           <div class="fashion-bundle__slot-remove" data-remove="${i}">&times;</div>
//         `;
//       }
//     });

//     /* ------------- MOBILE SLOTS -------------- */
//     mobileSlots.forEach((slot, i) => {

//       slot.innerHTML = "";
//       slot.style.background = "#767676";

//       const item = selectedItems[i];

//       if (i === MAX_SLOTS - 1) {

//         if (selectedItems.length === MAX_SLOTS) {
//           slot.classList.remove("fashion-bundle__slot--discount");
//           const lastItem = selectedItems[5];
//           slot.innerHTML = `
//             <img src="${lastItem.img}">
//             <div class="fashion-bundle__slot-remove" data-remove="5">&times;</div>
//           `;
//         } else {
//           slot.classList.add("fashion-bundle__slot--discount");
//           slot.innerHTML = slot.innerHTML; // preserve Liquid content
//         }
//         return;
//       }

//       if (item) {
//         slot.innerHTML = `
//           <img src="${item.img}">
//           <div class="fashion-bundle__slot-remove" data-remove="${i}">&times;</div>
//         `;
//       }
//     });

//     /* REMOVE HANDLERS */
//     root.querySelectorAll("[data-remove]").forEach((btn) => {
//       btn.addEventListener("click", () => {
//         const index = parseInt(btn.dataset.remove);
//         selectedItems.splice(index, 1);
//         renderSelected();
//         updateSummary();
//       });
//     });
//   }

//   /* --------------------------------------------
//      UPDATE SUMMARY (no percent override!)
//   --------------------------------------------- */
//   const lockIcon = `
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <path d="M12 2C13.5524 1.99994 15.0444 2.60157 16.1625 3.67847C17.2806 4.75537 17.9378 6.22371 17.996 7.775L18 8H19C19.5046 7.99984 19.9906 8.19041 20.3605 8.5335C20.7305 8.87659 20.9572 9.34685 20.995 9.85L21 10V20C21.0002 20.5046 20.8096 20.9906 20.4665 21.3605C20.1234 21.7305 19.6532 21.9572 19.15 21.995L19 22H5C4.49542 22.0002 4.00943 21.8096 3.63945 21.4665C3.26947 21.1234 3.04284 20.6532 3.005 20.15L3 20V10C2.99984 9.49542 3.19041 9.00943 3.5335 8.63945C3.87659 8.26947 4.34684 8.04284 4.85 8.005L5 8H6C6 6.4087 6.63214 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2ZM19 10H5V20H19V10ZM12 12C12.4266 12.0001 12.842 12.1367 13.1854 12.3896C13.5289 12.6426 13.7825 12.9988 13.9092 13.4062C14.0358 13.8135 14.0289 14.2507 13.8895 14.6538C13.75 15.057 13.4853 15.405 13.134 15.647L13 15.732V17C12.9997 17.2549 12.9021 17.5 12.7272 17.6854C12.5522 17.8707 12.313 17.9822 12.0586 17.9972C11.8042 18.0121 11.5536 17.9293 11.3582 17.7657C11.1627 17.6021 11.0371 17.3701 11.007 17.117L11 17V15.732C10.6187 15.5119 10.3208 15.1721 10.1523 14.7653C9.98384 14.3586 9.95429 13.9076 10.0682 13.4824C10.1822 13.0571 10.4333 12.6813 10.7825 12.4133C11.1318 12.1453 11.5597 12 12 12ZM12 4C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8H16C16 6.93913 15.5786 5.92172 14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4Z" fill="black"/>
//                 </svg>
//   `;

//   function updateSummary() {
//     const count = selectedItems.length;
//     let subtotal = selectedItems.reduce((sum, item) => sum + item.price, 0);

//     let appliedTier = null;
//     let nextTier = null;

//     tiers.forEach((tier) => {
//       if (count >= tier.items) appliedTier = tier;
//       if (!nextTier && count < tier.items) nextTier = tier;
//     });

//     let finalPrice = subtotal;
//     if (appliedTier) {
//       finalPrice = subtotal - (subtotal * appliedTier.discount / 100);
//     }

//     bundleTotalEls.forEach((el) => (el.textContent = finalPrice.toFixed(2) + "€"));

//     /* PROGRESS BAR ONLY */
//     let progress = 0;
//     if (appliedTier) {
//       progress = appliedTier.discount === tiers[0].discount ? 33 :
//                  appliedTier.discount === tiers[1].discount ? 66 :
//                  100;
//     }
//     tierProgress.style.width = progress + "%";

//     /* Desktop Messages */
//     if (count === 0) {
//       msgTop.innerHTML = "Füge Produkte hinzu, um dein Bundle zu starten!";
//       msgBottom.innerHTML = "";
//     } else {
//       if (appliedTier) {
//         msgTop.innerHTML =
//           `Du hast <strong>${count}</strong> Artikel hinzugefügt! <strong> Du sparst ${appliedTier.discount}%!</strong>`;
//         msgBottom.innerHTML = nextTier
//           ? `${lockIcon} Füge ${nextTier.items - count} mehr hinzu, um ${nextTier.discount}% zu sparen`
//           : `${lockIcon} Du hast den maximalen Rabatt erreicht!`
       

//       } else {
//         msgTop.innerHTML = `Du hast <strong>${count}</strong> Artikel hinzugefügt!`;
//         msgBottom.innerHTML = `${lockIcon} Füge mehr hinzu, um Rabatte freizuschalten!`;
//       }
//     }

//     msgTopMobile.innerHTML = msgTop.innerHTML;
//     msgBottomMobile.innerHTML = msgBottom.innerHTML;
//   }

//   /* --------------------------------------------
//      CHECKOUT — AJAX ADD
//   --------------------------------------------- */
//   function handleCheckout() {
//     if (selectedItems.length === 0) return;

//     finalBtnDesktop.classList.add("loading");
//     finalBtnDesktop.innerHTML = `<div class="fashion-bundle__loader"></div>`;

//     if (finalBtnMobile) {
//       finalBtnMobile.classList.add("loading");
//       finalBtnMobile.innerHTML = `<div class="fashion-bundle__loader"></div>`;
//     }

//     let queue = [...selectedItems];

//     const addNext = () => {
//       if (queue.length === 0) {
//         window.location.href = "/cart";
//         return;
//       }

//       const item = queue.shift();

//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: item.id, quantity: 1 })
//       })
//       .then(addNext)
//       .catch(addNext);
//     };

//     addNext();
//   }

//   finalBtnDesktop.addEventListener("click", handleCheckout);
//   if (finalBtnMobile) {
//     finalBtnMobile.addEventListener("click", handleCheckout);
//   }

//   /* INIT */
//   renderSelected();
//   updateSummary();
// });


document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".fashion-bundle");
  if (!root) return;

  /* --------------------------------------------
     ELEMENT REFERENCES
  --------------------------------------------- */
  const tabButtons = root.querySelectorAll(".fashion-bundle__tab-btn");
  const tabPanels = root.querySelectorAll("[data-tab-panel]");
  const selectedListDesktop = root.querySelector("[data-selected-list]");
  const selectedListMobile = root.querySelector("[data-selected-list-mobile]");
  const finalBtnDesktop = root.querySelector("[data-bundle-checkout]");
  const finalBtnMobile = root.querySelector(".fashion-bundle__final-btn-mobile");

  const progressEl = root.querySelector("[data-value-progress]");
  const msgTop = root.querySelector("[data-message-top]");
  const msgBottom = root.querySelector("[data-message-bottom]");
  const msgTopMobile = root.querySelector("[data-message-top-mobile]");
  const msgBottomMobile = root.querySelector("[data-message-bottom-mobile]");
  const bundleTotalEls = root.querySelectorAll("[data-bundle-total]");

  let selectedItems = [];

  /* --------------------------------------------
     TIER SETTINGS (FROM DATA ATTRIBUTES)
  --------------------------------------------- */
  const tiers = [
    { items: parseInt(root.dataset.tier1Items), discount: parseInt(root.dataset.tier1Discount) },
    { items: parseInt(root.dataset.tier2Items), discount: parseInt(root.dataset.tier2Discount) },
    { items: parseInt(root.dataset.tier3Items), discount: parseInt(root.dataset.tier3Discount) }
  ];

  const tierPercentMobile = root.querySelector('[data-tier1-percent-mobile]');
  const tierProgressMobile = root.querySelector('[data-tier-progress-mobile]');
  const tierLabelsMobile = {
    tier1: root.querySelector('[data-tier1-label-mobile]'),
    tier2: root.querySelector('[data-tier2-label-mobile]'),
    tier3: root.querySelector('[data-tier3-label-mobile]')
  };

  /* --------------------------------------------
     TAB SWITCHING - KEEPING YOUR CODE INTACT
  --------------------------------------------- */
  if (tabButtons.length > 0 && tabPanels.length > 0) {
    tabButtons.forEach(btn => btn.classList.remove("active"));
    tabPanels.forEach(panel => panel.classList.remove("active"));

    tabButtons[0].classList.add("active");
    tabPanels[0].classList.add("active");
  }

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      tabButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const id = btn.dataset.tab;

      tabPanels.forEach((panel) => {
        panel.classList.toggle("active", panel.id === id);
      });
    });
  });

  /* --------------------------------------------
     OPTION SELECTION HANDLING (Color, Size, etc.)
  --------------------------------------------- */
  // const optionSelectors = root.querySelectorAll('.option-selector');
  
  // optionSelectors.forEach((selector) => {
  //   selector.addEventListener('change', (event) => {
  //     const selectedOptionValue = event.target.value; // e.g., 'Red' for Color
  //     const selectedOptionName = event.target.dataset.option; // e.g., 'Color'
  //     const selectedProductId = event.target.dataset.productId; // product ID

  //     // Find the product card related to this selector (affected product)
  //     const productCard = event.target.closest('.fashion-bundle__product');
      
  //     // Fetch the variants and options from the <script> tag for this product (based on the product ID)
  //     const variantsScript = document.getElementById(`variants-${selectedProductId}`);
  //     const optionsScript = document.getElementById(`options-${selectedProductId}`);
      
  //     if (!variantsScript || !optionsScript) {
  //       console.error("Variants or options not found for product ID:", selectedProductId);
  //       return;  // Exit early if no variants or options data is found
  //     }

  //     const variants = JSON.parse(variantsScript.textContent);  // Parse the JSON variants data
  //     const options = JSON.parse(optionsScript.textContent);  // Parse the JSON options data

  //     // Get all selected options for this specific product card
  //     const selectedOptions = {};
  //     const productSelectors = productCard.querySelectorAll('.option-selector');
  //     productSelectors.forEach((optSelector) => {
  //       selectedOptions[optSelector.dataset.option] = optSelector.value;
  //     });

  //     // Find the matching variant for this product card based on selected options
  //     let selectedVariantId = productCard.querySelector('.selected-variant-id').value; // Start with the first variant ID initially

  //     // Loop through all variants and find the one that matches the selected options
  //     variants.forEach((variant) => {
  //       const variantOptions = variant.options.reduce((acc, option, index) => {
  //         // Match the variant options to the product options
  //         acc[options[index].name] = option;
  //         return acc;
  //       }, {});

  //       let isMatch = true;
  //       for (const option in selectedOptions) {
  //         if (variantOptions[option] !== selectedOptions[option]) {
  //           isMatch = false;
  //           break;
  //         }
  //       }

  //       // If a matching variant is found, update the selectedVariantId
  //       if (isMatch) {
  //         selectedVariantId = variant.id;
  //       }
  //     });

  //     // Update the hidden input with the correct variant ID for this specific product card
  //     const hiddenInput = productCard.querySelector('.selected-variant-id');
  //     hiddenInput.value = selectedVariantId;

  //     updateSummary();  // Optionally update the cart summary (if needed)
  //   });
  // });

  const optionSelectors = root.querySelectorAll('.option-selector');
  
  optionSelectors.forEach((selector) => {
    selector.addEventListener('change', (event) => {
      const selectedOptionValue = event.target.value; // e.g., 'Red' for Color
      const selectedOptionName = event.target.dataset.option; // e.g., 'Color'
      const selectedProductId = event.target.dataset.productId; // product ID

      // Find the product card related to this selector (affected product)
      const productCard = event.target.closest('.fashion-bundle__product');
      
      // Fetch the variants and options from the <script> tag for this product (based on the product ID)
      const variantsScript = document.getElementById(`variants-${selectedProductId}`);
      const optionsScript = document.getElementById(`options-${selectedProductId}`);
      
      if (!variantsScript || !optionsScript) {
        console.error("Variants or options not found for product ID:", selectedProductId);
        return;  // Exit early if no variants or options data is found
      }

      const variants = JSON.parse(variantsScript.textContent);  // Parse the JSON variants data
      const options = JSON.parse(optionsScript.textContent);  // Parse the JSON options data

      // Get all selected options for this specific product card
      const selectedOptions = {};
      const productSelectors = productCard.querySelectorAll('.option-selector');
      productSelectors.forEach((optSelector) => {
        selectedOptions[optSelector.dataset.option] = optSelector.value;
      });

      // Find the matching variant for this product card based on selected options
      let selectedVariantId = productCard.querySelector('.selected-variant-id').value; // Start with the first variant ID initially

      // Loop through all variants and find the one that matches the selected options
      variants.forEach((variant) => {
        const variantOptions = variant.options.reduce((acc, option, index) => {
          // Match the variant options to the product options
          acc[options[index].name] = option;
          return acc;
        }, {});

        let isMatch = true;
        for (const option in selectedOptions) {
          if (variantOptions[option] !== selectedOptions[option]) {
            isMatch = false;
            break;
          }
        }

        // If a matching variant is found, update the selectedVariantId
        if (isMatch) {
          selectedVariantId = variant.id;
        }
      });

      // Update the hidden input with the correct variant ID for this specific product card
      const hiddenInput = productCard.querySelector('.selected-variant-id');
      hiddenInput.value = selectedVariantId;

      // --- Update Variant Image in Product Card ---
      const selectedVariant = variants.find(v => v.id == selectedVariantId);

      if (selectedVariant && selectedVariant.featured_image) {
        const newImage = selectedVariant.featured_image.src;

        // Find the image element inside the product card
        const imgEl = productCard.querySelector(".fashion-bundle__product-image img");

        if (imgEl && newImage) {
          imgEl.src = newImage;
        }
      }

      updateSummary();  // Optionally update the cart summary (if needed)
    });
  });



  /* --------------------------------------------
     ADD ITEM TO BUNDLE (w/ loader)
  --------------------------------------------- */
  root.querySelectorAll("[data-add]").forEach((addBtn) => {
    addBtn.addEventListener("click", () => {

      addBtn.classList.add("loading");
      const originalText = addBtn.textContent;
      addBtn.innerHTML = `<div class="fashion-bundle__loader"></div>`;

      const productCard = addBtn.closest("[data-product]");
      const id = productCard.dataset.productId;
      const price = parseFloat(productCard.dataset.productPrice);
      const img = productCard.querySelector("img").src;

      // Get the selected variant ID from the hidden input field
      const selectedVariantId = productCard.querySelector('.selected-variant-id').value;

      setTimeout(() => {
        selectedItems.push({ id: selectedVariantId, price, img });

        addBtn.classList.remove("loading");
        addBtn.textContent = originalText;

        renderSelected();
        updateSummary();
      }, 250);
    });
  });

  /* --------------------------------------------
     RENDER SLOTS (STATIC 6 SLOTS)
  --------------------------------------------- */
  function renderSelected() {
    const desktopSlots = root.querySelectorAll("[data-slot]");
    const mobileSlots = root.querySelectorAll("[data-slot-mobile]");

    const MAX_SLOTS = 6;

    desktopSlots.forEach((slot, i) => {
      slot.innerHTML = "";
      slot.style.background = "#767676";

      const item = selectedItems[i];

      if (i === MAX_SLOTS - 1) {
        if (selectedItems.length === MAX_SLOTS) {
          slot.classList.remove("fashion-bundle__slot--discount");
          const lastItem = selectedItems[5];
          slot.innerHTML = `
            <img src="${lastItem.img}">
            <div class="fashion-bundle__slot-remove" data-remove="5">&times;</div>
          `;
        } else {
          slot.classList.add("fashion-bundle__slot--discount");
          slot.innerHTML = slot.innerHTML; 
        }
        return;
      }

      if (item) {
        slot.innerHTML = `
          <img src="${item.img}">
          <div class="fashion-bundle__slot-remove" data-remove="${i}">&times;</div>
        `;
      }
    });

    mobileSlots.forEach((slot, i) => {
      slot.innerHTML = "";
      slot.style.background = "#767676";

      const item = selectedItems[i];

      if (i === MAX_SLOTS - 1) {
        if (selectedItems.length === MAX_SLOTS) {
          slot.classList.remove("fashion-bundle__slot--discount");
          const lastItem = selectedItems[5];
          slot.innerHTML = `
            <img src="${lastItem.img}">
            <div class="fashion-bundle__slot-remove" data-remove="5">&times;</div>
          `;
        } else {
          slot.classList.add("fashion-bundle__slot--discount");
          slot.innerHTML = slot.innerHTML; 
        }
        return;
      }

      if (item) {
        slot.innerHTML = `
          <img src="${item.img}">
          <div class="fashion-bundle__slot-remove" data-remove="${i}">&times;</div>
        `;
      }
    });

    root.querySelectorAll("[data-remove]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const index = parseInt(btn.dataset.remove);
        selectedItems.splice(index, 1);
        renderSelected();
        updateSummary();
      });
    });
  }

  /* --------------------------------------------
     UPDATE SUMMARY
  --------------------------------------------- */
  // function updateSummary() {
  //   const count = selectedItems.length;
  //   let subtotal = selectedItems.reduce((sum, item) => sum + item.price, 0);

  //   let appliedTier = null;
  //   let nextTier = null;

  //   tiers.forEach((tier) => {
  //     if (count >= tier.items) appliedTier = tier;
  //     if (!nextTier && count < tier.items) nextTier = tier;
  //   });

  //   let finalPrice = subtotal;
  //   if (appliedTier) {
  //     finalPrice = subtotal - (subtotal * appliedTier.discount / 100);
  //   }

  //   bundleTotalEls.forEach((el) => (el.textContent = finalPrice.toFixed(2) + "€"));

  //   let progress = 0;
  //   if (appliedTier) {
  //     progress = appliedTier.discount === tiers[0].discount ? 33 :
  //                appliedTier.discount === tiers[1].discount ? 66 :
  //                100;
  //   }
  //   tierProgress.style.width = progress + "%";

  //   if (count === 0) {
  //     msgTop.innerHTML = "Füge Produkte hinzu, um dein Bundle zu starten!";
  //     msgBottom.innerHTML = "";
  //   } else {
  //     if (appliedTier) {
  //       msgTop.innerHTML =
  //         `Du hast <strong>${count}</strong> Artikel hinzugefügt! <strong> Du sparst ${appliedTier.discount}%!</strong>`;
  //       msgBottom.innerHTML = nextTier
  //         ? `Füge ${nextTier.items - count} mehr hinzu, um ${nextTier.discount}% zu sparen`
  //         : `Du hast den maximalen Rabatt erreicht!`;
  //     } else {
  //       msgTop.innerHTML = `Du hast <strong>${count}</strong> Artikel hinzugefügt!`;
  //       msgBottom.innerHTML = `Füge mehr hinzu, um Rabatte freizuschalten!`;
  //     }
  //   }

  //   msgTopMobile.innerHTML = msgTop.innerHTML;
  //   msgBottomMobile.innerHTML = msgBottom.innerHTML;
  // }

// function updateSummary() {
//   let bundleValue = selectedItems.reduce((sum, item) => sum + item.price, 0);

//   const thresholdDiscount = 59;
//   const thresholdGift = 80;

//   // Update totals
//   bundleTotalEls.forEach((el) => {
//     el.textContent = bundleValue.toFixed(2) + "€";
//   });

//   // Update progress bar
//   const percent = Math.min((bundleValue / thresholdGift) * 100, 100);
//   progressEl.style.width = percent + "%";

//   // Update messages
//   if (bundleValue === 0) {
//     msgTop.textContent = "Füge Produkte hinzu, um dein Bundle zu starten!";
//     msgBottom.textContent = "";
//   }
//   else if (bundleValue < thresholdDiscount) {
//     msgTop.textContent = "Fast geschafft!";
//     msgBottom.textContent = `${(thresholdDiscount - bundleValue).toFixed(2)}€ bis 30% Rabatt`;
//   }
//   else if (bundleValue < thresholdGift) {
//     msgTop.textContent = "🎉 30% Rabatt freigeschaltet!";
//     msgBottom.textContent = `${(thresholdGift - bundleValue).toFixed(2)}€ bis zur kostenlosen Überraschungssocke`;
//   }
//   else {
//     msgTop.textContent = "🎉 Glückwunsch!";
//     msgBottom.textContent = "Kostenlose Überraschungssocken aktiviert";
//   }

//   // Mobile sync
//   if (msgTopMobile) msgTopMobile.textContent = msgTop.textContent;
//   if (msgBottomMobile) msgBottomMobile.textContent = msgBottom.textContent;
// }

function updateSummary() {
    const count = selectedItems.length;
    let subtotal = selectedItems.reduce((sum, item) => sum + item.price, 0);

    let appliedTier = null;
    let nextTier = null;

    // Determine applied tier and next tier
    tiers.forEach((tier) => {
        if (count >= tier.items) appliedTier = tier;
        if (!nextTier && count < tier.items) nextTier = tier;
    });

    // Calculate final bundle price
    let finalPrice = subtotal;
    if (appliedTier) {
        finalPrice = subtotal - (subtotal * appliedTier.discount / 100);
    }

    // Update displayed price
    bundleTotalEls.forEach((el) => {
        el.textContent = finalPrice.toFixed(2) + "€";
    });

    // ===============================================================
    // === PROGRESS BAR (Desktop + Mobile)
    // ===============================================================

    const tierProgressDesktop = root.querySelector("[data-tier-progress]");
    const tierProgressMobile = root.querySelector("[data-tier-progress-mobile]");

    let progress = 0;

    if (appliedTier) {
        if (appliedTier.items === tiers[0].items) progress = 33;
        else if (appliedTier.items === tiers[1].items) progress = 66;
        else if (appliedTier.items === tiers[2].items) progress = 100;
    }

    if (tierProgressDesktop) tierProgressDesktop.style.width = progress + "%";
    if (tierProgressMobile) tierProgressMobile.style.width = progress + "%";


    // ===============================================================
    // === TIER MESSAGES (Desktop + Mobile)
    // ===============================================================

    // 0 items → hide everything
    if (count === 0) {
        msgTop.innerHTML = "";
        msgBottom.innerHTML = "";
        msgTop.style.display = "none";
        msgBottom.style.display = "none";

        msgTopMobile.innerHTML = "";
        msgBottomMobile.innerHTML = "";
        msgTopMobile.style.display = "none";
        msgBottomMobile.style.display = "none";
        return;
    }

    // Show message containers
    msgTop.style.display = "block";
    msgBottom.style.display = "block";
    msgTopMobile.style.display = "block";
    msgBottomMobile.style.display = "block";

    // Message logic
    if (count === 1) {
        msgTop.innerHTML = `Füge <strong>1 Produkt mehr</strong> hinzu für <strong>10% Rabatt</strong>`;
        msgBottom.innerHTML = "";
    }
    else if (count === 2) {
        msgTop.innerHTML = `Du sparst <strong>10%</strong>! Füge <strong>1 weitere Produkte</strong> hinzu für <strong>20% Rabatt</strong>`;
        msgBottom.innerHTML = "";
    }
    else if (count === 3) {
        msgTop.innerHTML = `Du sparst <strong>20%</strong>! Füge <strong>3 weitere Produkte</strong> hinzu für <strong>40% Rabatt + Gratis-Geschenk</strong>`;
        msgBottom.innerHTML = "";
    }
    else if (count === 4) {
        msgTop.innerHTML = `Du sparst <strong>20%</strong>! Füge <strong>2 weitere Produkte</strong> hinzu für <strong>40% Rabatt + Gratis-Geschenk</strong>`;
        msgBottom.innerHTML = "";
    }
    else if (count === 5) {
        msgTop.innerHTML = `Du sparst <strong>20%</strong>! Füge <strong>1 weitere Produkte</strong> hinzu für <strong>40% Rabatt + Gratis-Geschenk</strong>`;
        msgBottom.innerHTML = "";
    }
    else if (count >= 6) {
        msgTop.innerHTML = `🎉 Du hast <strong>40% Rabatt + Gratis-Socken</strong> freigeschaltet!`;
        msgBottom.innerHTML = `Bundle ist vollständig.`;
    }

    // Sync mobile messages
    msgTopMobile.innerHTML = msgTop.innerHTML;
    msgBottomMobile.innerHTML = msgBottom.innerHTML;
}





  /* --------------------------------------------
     CHECKOUT — AJAX ADD
  --------------------------------------------- */
  function handleCheckout() {
    if (selectedItems.length === 0) return;

    // Start loading
    finalBtnDesktop.classList.add("loading");
    if (finalBtnMobile) finalBtnMobile.classList.add("loading");

    let queue = [...selectedItems];

    const addNext = () => {
        if (queue.length === 0) {
            // Open drawer
            document.dispatchEvent(new CustomEvent("theme:product:added"));

            // Refresh cart
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent("theme:cart:refresh"));

                // STOP LOADING
                finalBtnDesktop.classList.remove("loading");
                if (finalBtnMobile) finalBtnMobile.classList.remove("loading");

            }, 300);

            return;
        }

        const item = queue.shift();

        fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.id, quantity: 1 })
        })
        .then(res => res.json())
        .then(data => {
            document.dispatchEvent(
                new CustomEvent("theme:cart:update", {
                    detail: { id: data.variant_id, quantity: data.quantity },
                    bubbles: true
                })
            );
            addNext();
        })
        .catch(() => addNext());
    };

    addNext();
}




  




  finalBtnDesktop.addEventListener("click", handleCheckout);
  if (finalBtnMobile) {
    finalBtnMobile.addEventListener("click", handleCheckout);
  }

  /* INIT */
  renderSelected();
  updateSummary();
});










